declare let APP_CONFIG: any;

export default APP_CONFIG;
